import { ClipboardList } from 'lucide-react';
import { cn } from '@/lib/utils';

interface EvalAverages {
  effort: number;
  engagement: number;
  competitionLevel: number;
  attitude: number;
}

interface EvaluationsSectionProps {
  evalAverages: EvalAverages;
}

function MetricCard({ label, value }: { label: string; value: number }) {
  const colorClass = value >= 3.5 ? 'text-green-600 bg-green-50' :
                     value >= 2.5 ? 'text-blue-600 bg-blue-50' :
                     value >= 1.5 ? 'text-amber-600 bg-amber-50' :
                     'text-red-600 bg-red-50';

  return (
    <div className={cn('rounded-lg p-4 text-center', colorClass)}>
      <p className="text-2xl font-bold">{value.toFixed(1)}</p>
      <p className="text-sm opacity-75">{label}</p>
    </div>
  );
}

export function EvaluationsSection({ evalAverages }: EvaluationsSectionProps) {
  return (
    <div className="bg-card rounded-lg shadow p-6">
      <div className="flex items-center gap-2 mb-4">
        <ClipboardList className="w-5 h-5 text-muted-foreground" />
        <h2 className="font-semibold">Evaluation Averages</h2>
        <span className="text-sm text-muted-foreground">(last 10 evaluations)</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <MetricCard label="Effort" value={evalAverages.effort} />
        <MetricCard label="Engagement" value={evalAverages.engagement} />
        <MetricCard label="Competition" value={evalAverages.competitionLevel} />
        <MetricCard label="Attitude" value={evalAverages.attitude} />
      </div>
    </div>
  );
}
